<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizLista
            idTipoOpex="2"
            tipoOpex="pack"
            nombreTipoOpex="Packing"
            vAuthAcl="gh-pres-opex-pck"
            v-auth-acl="'gh-pres-opex-pck'"
          ></MatrizLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexPacking',
  components: {
    MatrizLista: () => import('../../components/MatrizLista')
  },
  data: () => ({
    page: {
      title: 'OPEX Packing'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Packing',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
